export default "__VITE_ASSET__DP5V3Wfl__"